import { CORE_TEXT, createLocaleTextHook } from '@moonpig/web-core-locale-text'
import { USP_TEXT } from './components/FlowersUSP/FlowersUSP.locale'

export const TABS_TEXT = {
  'tabs.single_card': {
    'en-GB': 'Single Card',
    'nl-NL': 'Eén kaart',
  },
  'tabs.single_card_label': {
    'en-GB': 'Show single card options',
    'nl-NL': 'Opties voor enkele kaarten weergeven',
  },
  'tabs.multi_card': {
    'en-GB': 'Multi-Card',
    'nl-NL': 'Stapelkorting',
  },
  'tabs.multi_card_label': {
    'en-GB': 'Show multi-card options',
    'nl-NL': 'Stapelkorting weergeven',
  },
  'tabs.group_card': {
    'en-GB': 'Group Card',
    'nl-NL': 'Groepskaart',
  },
  'tabs.group_card_label': {
    'en-GB': 'Show group card options',
    'nl-NL': 'Toon opties voor groepswenskaart',
  },
  'tabs.card': {
    'en-GB': 'Card',
    'nl-NL': 'Kaart',
  },
  'tabs.card_label': {
    'en-GB': 'Show card options',
    'nl-NL': '',
  },
  'tabs.group_card_list_title': {
    'en-GB': 'Your friends can write inside too!',
    'nl-NL': '',
  },
  'tabs.group_card_list_item_1': {
    'en-GB': "Make this a <b>'Group Card'</b>",
    'nl-NL': '',
  },
  'tabs.group_card_list_item_2': {
    'en-GB':
      '<b>Set a deadline, then share a link</b> for others to sign online',
    'nl-NL': '',
  },
  'tabs.group_card_list_item_3': {
    'en-GB': '<b>No account required</b> for them to sign',
    'nl-NL': '',
  },
  'tabs.group_card_list_item_4': {
    'en-GB': 'Collect up to <b>50 messages</b>',
    'nl-NL': '',
  },
}

export const CTA_TEXT = {
  'common.add_gift_to_a_card': {
    'en-GB': 'Add Gift to a Card',
    'nl-NL': 'Toevoegen aan een kaart',
  },
  'common.add_to_card': {
    'en-GB': 'Add to Card',
    'nl-NL': 'Toevoegen aan een kaart',
  },
}

export const SPONSORED_PILL_TEXT = {
  'sponsored_pill.pill_label': {
    'en-GB': 'Sponsored',
    'nl-NL': 'Samenwerking',
  },
  'sponsored_pill.modal_label': {
    'en-GB': 'Sponsored Content',
    'nl-NL': 'Gesponsorde content',
  },
  'sponsored_pill.modal_content': {
    'en-GB':
      'We collaborate with brand partners to show you products that could be relevant and interesting to you.',
    'nl-NL':
      'We werken samen met merkpartners om je producten te tonen die relevant en interessant voor je kunnen zijn.',
  },
}

export const MULTI_CARD_PROMOTION = {
  'multicard.how_to_send_to_different_addresses': {
    'en-GB': 'How to send to different addresses',
    'nl-NL': 'Zo verstuur je iets naar verschillende adressen',
  },
  'multicard.download_csv_template': {
    'en-GB': 'Download our CSV template',
    'nl-NL': 'Download het CSV-template',
  },
  'multicard.multi_buy_discounts_apply_to_all_cards_in_your_basket': {
    'en-GB': 'Multi-Card discounts apply to all cards in your basket',
    'nl-NL': 'De stapelkorting geldt voor alle kaarten in je winkelmandje',
  },
  'multicard.multi_buy_promo_tag_text': {
    'en-GB': 'Offer',
    'nl-NL': 'Korting',
  },
  'multicard.discount': {
    'en-GB': (c: { discount: number }) => `Get ${c.discount}% off`,
    'nl-NL': (c: { discount: number }) => `${c.discount}% korting`,
  },
  'multicard.discount_simplified': {
    'en-GB': (c: { discount: number }) => `${c.discount}% off`,
    'nl-NL': (c: { discount: number }) => `${c.discount}% korting`,
  },
  'multicard.regular_price_and_discounted_price': {
    'en-GB': (c: {
      regularPrice: string
      discountedPrice: string
      discount: number
      code: string
    }) =>
      `Regular price is ${c.regularPrice} and discounted price is ${c.discountedPrice} (${c.discount}% off with code ${c.code}})`,
    'nl-NL': (c: {
      regularPrice: string
      discountedPrice: string
      discount: number
    }) =>
      `De prijs is normaal ${c.regularPrice} en met korting is deze ${c.discountedPrice} (${c.discount}% korting)`,
  },
}

export const MESSAGING = {
  'messaging.sold_out': {
    'en-GB': 'This item is either sold out or no longer available.',
    'nl-NL': 'Dit artikel is uitverkocht of niet langer beschikbaar',
  },
  'messaging.its_not_you': {
    'en-GB': "It's not you, it's us. Please try again!",
    'nl-NL': 'Het ligt niet aan jou, het ligt aan ons. Probeer het nog eens!',
  },
}

export const RATING = {
  'rating.rating_count': {
    'en-GB': (count: number) => `${Number(count).toLocaleString('en-GB')}`,
    'nl-NL': (count: number) => `${Number(count).toLocaleString('nl-NL')}`,
  },
  'rating.total_reviews': {
    'en-GB': 'Total reviews',
    'nl-NL': 'Totaal aantal beoordelingen',
  },
}

export const PRODUCT_VIDEO = {
  'product_video.video_label': {
    'en-GB': 'Video',
  },
  'product_video.play_video_label': {
    'en-GB': (productTitle: string) =>
      `Play video for ${productTitle} product information`,
  },
  'product_video.video_thumbnail': {
    'en-GB': (productTitle: string) =>
      `Video thumbnail for ${productTitle} product information`,
  },
}

export const PRODUCT_IMAGE = {
  'product_image.image_label': {
    'en-GB': (productTitle: string, index: number) =>
      `${productTitle} image ${index}`,
    'nl-NL': (productTitle: string, index: number) =>
      `${productTitle} afbeelding ${index}`,
  },
}

export const FAVOURITES = {
  'favourites.item_added_to_your_favourites': {
    'en-GB': 'Item added to your Favourites',
    'nl-NL': 'Artikel toegevoegd aan favorieten',
  },
  'favourites.view': {
    'en-GB': 'View',
    'nl-NL': 'Bekijk',
  },
}

export const MEMBER_PRICING_HEADER = {
  'member_pricing_header.title': {
    'en-GB': (customerName: string, offerPercent = 30) =>
      `<span class="mp-mask">${customerName}</span>, you get <span style="color:#CE3356"><b>${offerPercent}% off</b></span> any size card.`,
    'nl-NL': (customerName: string, offerPercent = 30) =>
      `<span class="mp-mask">${customerName}</span>, je krijgt <span style="color:#F5084A"><b>${offerPercent}% korting</b></span> op elke kaartgrootte.`,
  },
  'member_pricing_header.subtitle': {
    'en-GB': `Discount applied at checkout.`,
    'nl-NL': `Korting toegepast bij het afrekenen.`,
  },
}

export const POSTCARD_UPSELL_TEXT = {
  'postcard_upsell.description': {
    'en-GB':
      'Need more space? Switch your card now to a standard, large, or mega card.',
    'nl-NL':
      'Meer ruimte nodig?  Zet je kaart nu om naar een standaard, grote of mega kaart.',
  },
  'postcard_upsell.cta': {
    'en-GB': 'Yes, upgrade my postcard',
    'nl-NL': 'Ja, upgrade mijn ansichtkaart',
  },
}

export const SELECT_CARD_TEXT = {
  'select_card.title': {
    'en-GB': 'What card should we add it to?',
    'nl-NL': 'Welke kaart wil je erbij?',
  },
  'select_card.subtitle': {
    'en-GB': 'Select from your basket or pick a new card',
    'nl-NL': 'Kies er een in je winkelmandje of een nieuwe',
  },
  'select_card.cta_primary': {
    'en-GB': 'Continue',
    'nl-NL': 'Doorgaan',
  },
  'select_card.cta_no_cards': {
    'en-GB': 'Add Gift to a Card',
    'nl-NL': 'Toevoegen aan een kaart',
  },
  'select_card.select_new': {
    'en-GB': 'Select new',
    'nl-NL': 'Nieuwe kiezen',
  },
  'select_card.loading': {
    'en-GB': 'Loading your basket',
    'nl-NL': 'Aan het laden van je winkelmandje',
  },
  'select_card.card_aria_label': {
    'en-GB': (title: string) => `Select card: ${title}`,
    'nl-NL': (title: string) => `Kaart selecteren: ${title}`,
  },
}

export const SELLING_POINTS_TEXT = {
  'selling_points.immediate_delivery_with_ecard': {
    'en-GB': 'Immediate delivery when you send in an eCard',
    'nl-NL': 'Directe levering wanneer je verstuurt in een eCard',
  },
  'selling_points.printed_inside_card': {
    'en-GB': 'This gift will be printed inside a card',
    'nl-NL': 'Dit cadeau wordt in een kaart gedrukt',
  },
}

const VARIANT_TABS = {
  'variant_tabs.card': {
    'en-GB': (price: string) => `Card from ${price}`,
    'nl-NL': (price: string) => `Kaarten vanaf ${price}`,
  },
  'variant_tabs.ecard': {
    'en-GB': (price: string) => `eCard ${price}`,
    'nl-NL': (price: string) => `eKaarten ${price}`,
  },
  'variant_tabs.select_size': {
    'en-GB': 'Select size in the next step',
    'nl-NL': 'Kies formaat in volgende stap',
  },
  'variant_tabs.sent_via_email': {
    'en-GB': 'Sent instantly by email',
    'nl-NL': 'Direct per e-mail verzonden',
  },
  'variant_tabs.sizes_available': {
    'en-GB': 'Sizes available',
    'nl-NL': 'Beschikbare formaten',
  },
}

const VARIANT_SELECTOR = {
  'variant_selector.select_amount': {
    'en-GB': 'Select Amount',
    'nl-NL': 'Kies een bedrag',
  },
  'price_variant_selector.select_amount_to_continue': {
    'en-GB': 'Select an amount to continue',
    'nl-NL': 'Kies een bedrag om verder te gaan',
  },
  'price_variant_selector.close_select_amount_warning': {
    'en-GB': 'Close select amount warning',
    'nl-NL': 'Sluit melding bedrag kiezen',
  },
  'price_variant_selector.select_bouquet_size_to_continue': {
    'en-GB': 'Select your bouquet size to continue',
    'nl-NL': 'Kies je formaat boeket om verder te gaan',
  },
  'price_variant_selector.close_bouquet_size_warning': {
    'en-GB': 'Close select bouquet size warning',
    'nl-NL': 'Sluit waarschuwing formaat boeket kiezen',
  },
  'variant_selector.plus_delivery': {
    'en-GB': '+ delivery',
    'nl-NL': '+ levering',
  },
  'variant_selector.footer_line_one': {
    'en-GB': 'Delivery options vary depending on card size.',
    'nl-NL': 'De leveringsopties variëren afhankelijk van de kaartgrootte.',
  },
  'variant_selector.footer_line_two_part_one': {
    'en-GB': 'See ',
    'nl-NL': 'Bekijk ',
  },
  'variant_selector.footer_line_two_part_two': {
    'en-GB': 'delivery information',
    'nl-NL': 'leveringsinformatie',
  },
  'variant_selector.footer_line_two_part_three': {
    'en-GB': ' page for more details.',
    'nl-NL': ' pagina voor meer details.',
  },
}

const CONFIRMATION_BUTTON = {
  'confirmation_button.added_to_basket': {
    'en-GB': 'Added to Basket',
    'nl-NL': 'In winkelmand', // same like for "Add to basket", but on CTA we add a tick icon
  },
}

const HEADING = {
  heading: {
    'en-GB': 'Choose card type',
    'nl-NL': 'Kies een ontwerp',
  },
}

const FILTERS = {
  'filters.quick_filters': {
    'en-GB': 'Quick filters',
    'nl-NL': 'Snelle filters',
  },
  'filters.clear_selection': {
    'en-GB': 'clear selection',
    'nl-NL': 'selectie wissen',
  },
  'filters.clear': {
    'en-GB': 'Clear',
    'nl-NL': 'Reset',
  },
  'filters.sort': {
    'en-GB': 'Sort',
    'nl-NL': 'Sorteren',
  },
  'filters.all': {
    'en-GB': (c: { label: string | undefined }) => {
      return `All ${c.label}`
    },
    'nl-NL': (c: { label: string | undefined }) => {
      return `Alle ${c.label}`
    },
  },
  'filters.filters_menu_panel.close': {
    'en-GB': (title: string) => `Close ${title} menu`,
    'nl-NL': /* istanbul ignore next */ (title: string) =>
      `Menu ${title} sluiten`,
  },
  'filters.filters_menu_panel.open': {
    'en-GB': (title: string) => `Open ${title} menu`,
    'nl-NL': /* istanbul ignore next */ (title: string) =>
      `Menu ${title} openen`,
  },
  'filters.view_n_results': {
    'en-GB': (c: { resultsCount: number }) => {
      return c.resultsCount > 1
        ? `View ${Intl.NumberFormat('en-GB', { style: 'decimal' }).format(
            c.resultsCount,
          )} results`
        : `View ${Intl.NumberFormat('en-GB', { style: 'decimal' }).format(
            c.resultsCount,
          )} result`
    },
    'nl-NL': (c: { resultsCount: number }) => {
      return c.resultsCount > 1
        ? `Bekijk ${Intl.NumberFormat('nl-NL').format(
            c.resultsCount,
          )} resultaten`
        : `Bekijk ${Intl.NumberFormat('nl-NL').format(
            c.resultsCount,
          )} resultaat`
    },
  },
  'filters.filter_menu_panel.open': {
    'en-GB': (title: string) => `Open ${title} menu`,
    'nl-NL': /* istanbul ignore next */ (title: string) =>
      `Menu ${title} openen`,
  },
}

const VARIANT_INFO_TEXT = {
  'common.select_size': {
    'en-GB': 'Select Size',
    'nl-NL': 'Kies het formaat',
  },
  'common.what_size': { 'en-GB': 'What Size?', 'nl-NL': 'Welk formaat?' },
  'common.select_bouquet_size': {
    'en-GB': 'Select bouquet size',
    'nl-NL': 'Selecteer formaat boeket',
  },
  'common.flower_variant_description_standard': {
    'en-GB': 'To show them you care',
    'nl-NL': 'Laat zien dat je om hen geeft',
  },
  'common.flower_variant_description_large': {
    'en-GB': 'Moonpig favourite',
    'nl-NL': 'Favoriet op Greetz',
  },
  'common.flower_variant_description_giant': {
    'en-GB': 'For the biggest moments',
    'nl-NL': 'Voor een extra groots gebaar',
  },
  'common.who_is_it_for': {
    'en-GB': 'Who is it for?',
    'nl-NL': 'Voor wie is het?',
  },
  'common.size_info': {
    'en-GB': 'Size info',
    'nl-NL': 'Informatie over het formaat',
  },
  'common.colour': { 'en-GB': 'Colour', 'nl-NL': 'Kleur' },
  'common.choose_the_colour_at_the_next_step': {
    'en-GB': 'Choose the colour at the next step',
    'nl-NL': 'Kies de kleur bij de volgende stap',
  },
}

const GROUP_CARD = {
  'group_card.make_group_card': {
    'en-GB': 'Make Group Card',
    'nl-NL': 'Groepswenskaart maken',
  },
}

const PRICE_SUFFIX_TEXT = {
  'price.delivery': {
    'en-GB': '+ delivery',
    'nl-NL': '',
  },
}

const MULTI_BUY_LIST = {
  'multi_buy_list.error_try_again': {
    'en-GB': 'An error occurred, please try again!',
    'nl-NL': 'Er is een fout opgetreden, probeer het opnieuw!',
  },
  'multi_buy_list.limit_reached': {
    'en-GB': (limit: number) =>
      `You can only add up to ${limit} products to your shopping list`,
    'nl-NL': (limit: number) =>
      `Je kunt maximaal ${limit} producten toevoegen aan je winkelmandje`,
  },
}

export type ProductsDictionary =
  | keyof typeof TABS_TEXT
  | keyof typeof MULTI_CARD_PROMOTION
  | keyof typeof MESSAGING
  | keyof typeof POSTCARD_UPSELL_TEXT
  | keyof typeof SELLING_POINTS_TEXT

export const useProductsLocaleText = createLocaleTextHook({
  dictionary: {
    ...CORE_TEXT,
    ...VARIANT_INFO_TEXT,
    ...GROUP_CARD,
    ...TABS_TEXT,
    ...MULTI_CARD_PROMOTION,
    ...MESSAGING,
    ...SPONSORED_PILL_TEXT,
    ...RATING,
    ...PRODUCT_VIDEO,
    ...PRODUCT_IMAGE,
    ...FAVOURITES,
    ...MEMBER_PRICING_HEADER,
    ...VARIANT_TABS,
    ...CONFIRMATION_BUTTON,
    ...VARIANT_SELECTOR,
    ...HEADING,
    ...FILTERS,
    ...USP_TEXT,
    ...CTA_TEXT,
    ...PRICE_SUFFIX_TEXT,
    ...POSTCARD_UPSELL_TEXT,
    ...SELECT_CARD_TEXT,
    ...SELLING_POINTS_TEXT,
    ...MULTI_BUY_LIST,
  },
})
